import { useQuery } from 'react-query';
import axios from 'axios';
import { AdminAnalyticsAndReportsAPI } from '../../../../constants/API';
import { commonHeaders } from '../../../../constants/HeadersAPI';
import { AnalyticsAndReportsDateType } from '../../../../types/Admin/AnalyticsAndReports';
import {
  QualityReportData,
  QualityReportEmployeeRow
} from '../../../../types/Admin/QualityReport';

type QualityReportEmployeeApi = {
  employeeId: number;
  employeeName: string;
  ratingsCount: number | null;
  averageRating: number | null;
  score1: number | null;
  score2: number | null;
  score3: number | null;
  score4: number | null;
  score5: number | null;
};

type QualityReportApiResponse = {
  employees: QualityReportEmployeeApi[];
  totals: QualityReportEmployeeApi | null;
};

const mapRow = (row: QualityReportEmployeeApi, isSummary = false): QualityReportEmployeeRow => ({
  employeeId: row.employeeId,
  employeeName: row.employeeName,
  ratingsCount: row.ratingsCount,
  averageRating: row.averageRating != null ? Number(row.averageRating) : null,
  score1: row.score1,
  score2: row.score2,
  score3: row.score3,
  score4: row.score4,
  score5: row.score5,
  isSummary
});

const emptyTotals = (): QualityReportEmployeeRow => ({
  employeeName: 'Итого по очереди',
  ratingsCount: null,
  averageRating: null,
  score1: null,
  score2: null,
  score3: null,
  score4: null,
  score5: null,
  isSummary: true
});

export const useGetQualityReport = (
  date: AnalyticsAndReportsDateType,
  enabled: boolean
) => {
  const {
    data: qualityReportData,
    isFetching: isLoadingQualityReport,
    isSuccess: isQualityReportReceived,
    refetch: refetchQualityReport,
    error
  } = useQuery(
    [
      'qualityReport',
      date.startDate,
      date.endDate,
      date.branchQueueId ?? null,
      date.employeeId ?? null
    ],
    () =>
      axios.get<QualityReportApiResponse>(
        `${AdminAnalyticsAndReportsAPI.getQualityReport}?startDate=${date.startDate}&endDate=${date.endDate}&branchQueueId=${date.branchQueueId}${
          date.employeeId ? `&employeeId=${date.employeeId}` : ''
        }`,
        commonHeaders()
      ),
    {
      enabled: enabled && date.branchQueueId != null,
      select: ({ data }): QualityReportData => {
        const employees = (data?.employees ?? []).map((row) => mapRow(row));
        const totals = data?.totals
          ? mapRow({ ...data.totals, employeeName: 'Итого по очереди' }, true)
          : emptyTotals();
        const hasRatings = (totals.ratingsCount ?? 0) > 0;

        return {
          employees,
          totals,
          hasRatings
        };
      }
    }
  );

  return {
    qualityReportData,
    isLoadingQualityReport,
    isQualityReportReceived,
    refetchQualityReport,
    qualityReportError: error
  };
};
